module.exports = __webpack_public_path__ + "static/media/request-tablet.48f82106.svg";